import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import './Card.css'

export default function ActionAreaCard(props) {
    const { image, titleImage, type, expirate } = props
    return (
        <div className="containerCard">
            <Card sx={{
                maxWidth: '20.563rem',
                maxHigh: '18.75rem',
            }}>

                <CardActionArea className="cardd">
                    <CardMedia
                        component="img"
                        image={image}
                        height="200"
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            {titleImage}
                        </Typography>
                        <Typography variant="h6" color="text.secondary">
                            <h5>Tipo de licença: {type} </h5>
                        </Typography>
                        <Typography variant="subtitle1" color="text.secondary">
                            <h5>Validade da licença: {expirate} </h5>
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card >
        </div >
    );
}